import React from 'react';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface TestimonialCardProps {
  name: string;
  role: string;
  image: string;
  alt: string;
  rating: number;
  comment: string;
  date: string;
}

const TestimonialCard = ({ name, role, image, alt, rating, comment, date }: TestimonialCardProps) => {
  return (
    <div className="bg-card rounded-xl p-6 shadow-soft hover:shadow-elevated transition-all duration-base">
      <div className="flex items-start space-x-4 mb-4">
        <div className="relative w-16 h-16 rounded-full overflow-hidden flex-shrink-0">
          <AppImage
            src={image}
            alt={alt}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex-1">
          <h4 className="font-headline font-bold text-text-primary">{name}</h4>
          <p className="text-sm text-text-secondary font-body">{role}</p>
          <div className="flex items-center space-x-1 mt-1">
            {[...Array(5)].map((_, index) => (
              <Icon
                key={index}
                name="StarIcon"
                size={16}
                variant={index < rating ? "solid" : "outline"}
                className={index < rating ? "text-accent" : "text-gray-300"}
              />
            ))}
          </div>
        </div>
      </div>
      
      <p className="text-text-primary font-body leading-relaxed mb-4">
        "{comment}"
      </p>
      
      <div className="flex items-center justify-between text-sm text-text-secondary font-body">
        <span>{date}</span>
        <Icon name="CheckBadgeIcon" size={20} variant="solid" className="text-success" />
      </div>
    </div>
  );
};

export default TestimonialCard;